import { z } from 'zod';
import {
  RATE_MODE_OPTIONS,
  rateModeDefaults,
  rateModeFields,
  refineRateMode,
} from '../../../playground/endpoints/_shared';
import {
  CONTRIBUTION_PERIODICITY_OPTIONS,
  GENDER_OPTIONS,
  PAYMENT_PERIODICITY_OPTIONS,
  REGIME_OPTIONS,
  contributionSchema,
} from '../_shared';

export {
  CONTRIBUTION_PERIODICITY_OPTIONS,
  GENDER_OPTIONS,
  PAYMENT_PERIODICITY_OPTIONS,
  RATE_MODE_OPTIONS,
  REGIME_OPTIONS,
};
export type { ContributionFormValue } from '../_shared';

export const apvSelectOneSchema = z.object({
  date_of_birth: z
    .string()
    .min(1, 'Requerido')
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato YYYY-MM-DD'),
  gender: z.enum(['MALE', 'FEMALE', 'OTHER']),
  net_salary: z.coerce.number().nonnegative('Debe ser ≥ 0'),
  regime: z.enum(['A', 'B']),
  ...rateModeFields,
  death_insured_capital: z.coerce.number().nonnegative(),
  accidental_death_insured_capital: z.coerce.number().nonnegative(),
  itp_insured_capital: z.coerce.number().nonnegative(),
  contributions: z.array(contributionSchema),
  incoming_apv_transfer: z.coerce.number().nonnegative(),
  agreed_deposits: z.array(contributionSchema),
  agreed_premium: z.coerce.number().nonnegative(),
  payment_periodicity: z.enum(['monthly', 'quarterly', 'semiannual', 'annual']),
})
  .superRefine(refineRateMode);

export type ApvSelectOneFormValues = z.infer<typeof apvSelectOneSchema>;

export type ApvSelectOneRegime = ApvSelectOneFormValues['regime'];

export const isFixedRate = (v: ApvSelectOneFormValues) => v.rate_mode === 'fixed';
export const isSteppedRate = (v: ApvSelectOneFormValues) => v.rate_mode === 'stepped';

export const apvSelectOneDefaults: ApvSelectOneFormValues = {
  date_of_birth: '1990-01-01',
  gender: 'MALE',
  net_salary: 1500000,
  regime: 'A',
  ...rateModeDefaults,
  projection_rate: 0.0331,
  death_insured_capital: 150,
  accidental_death_insured_capital: 0,
  itp_insured_capital: 0,
  contributions: [{ amount: 5, periodicity: 'monthly', start_month: 0 }],
  incoming_apv_transfer: 3000,
  agreed_deposits: [],
  agreed_premium: 0,
  payment_periodicity: 'monthly',
};
